export const PHONE_NUMBER_DIGITS_COUNT = 11;
